import React from "react";
import { motion } from "motion/react";
import { Spinner } from "reactstrap";

const SimpleLoadingSpinner = ({ message }: { message?: string }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{
        opacity: 0,
        transition: { duration: 0.3 }
      }}
      transition={{
        duration: 0.2
      }}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "10vh"
      }}
      aria-busy
    >
      <Spinner />
      {message && <div>{message}</div>}
    </motion.div>
  );
};

export default SimpleLoadingSpinner;
